import { useEffect } from 'react'
import { useLocalStorage } from '@/lib/hooks'

export type Theme = 'system' | 'light' | 'dark'

const darkQuery = () => window.matchMedia('(prefers-color-scheme: dark)')

/**
 * Theme preference. "system" is resolved here (and re-resolved when the OS setting changes) so the
 * stylesheet only has to define one explicit data-theme per scheme.
 */
export function useTheme(): [Theme, (theme: Theme) => void] {
  const [theme, setTheme] = useLocalStorage<Theme>('cockpit.theme', 'system')

  useEffect(() => {
    const apply = () => {
      const resolved = theme === 'system' ? (darkQuery().matches ? 'dark' : 'light') : theme
      document.documentElement.setAttribute('data-theme', resolved)
    }
    apply()
    if (theme !== 'system') return
    const query = darkQuery()
    query.addEventListener('change', apply)
    return () => query.removeEventListener('change', apply)
  }, [theme])

  return [theme, setTheme]
}
